import * as React from "react";
import { SVGProps } from "react";
const SvgSocialLinkedIn = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23.605 23.419v-5.701c0-3.051-1.634-4.469-3.809-4.469-1.776 0-2.563.99-2.995 1.677h.03V13.48h-3.31s.045.93 0 9.939h3.31V17.86c0-.286.015-.588.1-.802.242-.588.787-1.203 1.704-1.203 1.187 0 1.662.902 1.662 2.25v5.313h3.308v.001Zm-15.21 0h3.308V13.48H8.395v9.939ZM10.07 8.695c-1.131 0-1.876.744-1.876 1.719 0 .898.647 1.641 1.669 1.713l.177.006c1.16 0 1.877-.774 1.877-1.72-.014-.925-.648-1.643-1.68-1.713l-.167-.005ZM27 22.875A4.125 4.125 0 0 1 22.873 27H9.127A4.127 4.127 0 0 1 5 22.875V9.125A4.126 4.126 0 0 1 9.127 5h13.746A4.126 4.126 0 0 1 27 9.125v13.75Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSocialLinkedIn;
